import { Text } from '@cko/primitives';
import styled from 'styled-components';

export const Heading = styled(Text)`
  font: var(--heading-sm);
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 640px;
  min-height: 496px;
  overflow-y: auto;
  width: 450px;
`;
